export default __webpack_public_path__ + "static/media/wordmark-seamless.3e0ae85b.svg";